import { BasicRequest } from "./basicRequest";

export class AdoptMoovDefinitionRequest extends BasicRequest{
    public moovDefinitionId! : number;
}